import React from "react";
import clsx from "clsx";
import { Row, Col } from "react-bootstrap";

import { Skeleton, OnlineLink } from "components";

import CheckImages from "static/images/checked.png";
import styles from "./textWithLoader.module.scss";

type TextWithLoaderProps = {
	label?: string;
	value?: string | number | HTMLElement | JSX.Element | any;
	additionalValue?: string | number;
	loading?: boolean;
	loadingLabel?: boolean;
	isHideLabel?: boolean;
	labelCol?: number;
	valueCol?: number;
	labelClass?: string;
	valueClass?: string;
	className?: string;
	linkTo?: string;
	labelLinkTo?: string;
	handleClick?: (any) => void;
	target?: string;
	leftAddon?: React.ReactNode;
	rightAddon?: React.ReactNode;
	dataAutotest?: string;
	isIconCheck?: boolean;
};

const TextWithLoader = ({
	label,
	value,
	additionalValue,
	loading = false,
	loadingLabel = false,
	isHideLabel = false,
	labelCol = 5,
	valueCol = 7,
	labelClass,
	valueClass,
	linkTo,
	labelLinkTo,
	handleClick,
	className,
	target,
	leftAddon,
	rightAddon,
	dataAutotest,
	isIconCheck,
}: TextWithLoaderProps) => {
	const checkIcon = isIconCheck ? (
		<span className={clsx(styles.iconCheck, "mr-2")}>
			<img src={CheckImages} alt="" />
		</span>
	) : null;
	return (
		<Row className={clsx(styles.formGroup, className)}>
			{!isHideLabel && (
				<Col
					sm={labelCol}
					className={clsx(styles.labelColor, labelClass)}
				>
					{loadingLabel ? (
						<Skeleton variant="text" height="24px" width="100%" />
					) : labelLinkTo ? (
						<OnlineLink to={labelLinkTo} target={target}>
							{label}
						</OnlineLink>
					) : (
						<>{label}</>
					)}
				</Col>
			)}
			<Col sm={valueCol} className={clsx(valueClass)}>
				<div className="d-flex">
					{loading ? (
						<Skeleton variant="text" height="24px" width="100%" />
					) : linkTo && value ? (
						<OnlineLink to={linkTo} target={target}>
							{leftAddon} {value}
						</OnlineLink>
					) : handleClick && value ? (
						<span
							onClick={handleClick}
							className={styles.link}
							data-autotest={dataAutotest}
						>
							{leftAddon} {checkIcon} {value}
						</span>
					) : value ? (
						<span data-autotest={dataAutotest}>
							{leftAddon}
							{checkIcon}
							{value}
						</span>
					) : null}
					{rightAddon}
				</div>
				{additionalValue && (
					<div className={styles.additionalValue}>
						{additionalValue}
					</div>
				)}
			</Col>
		</Row>
	);
};

export default TextWithLoader;
